import React, { useState, useEffect } from "react";
import { Card, Button, Modal, Form, Row, Col } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";

import Layout from "../../layout/default";
import Block from "../../components/Block/Block";
import DataTable from "../../components/DataTable/DataTable";
import { Icon } from "../../components";

import Swal from "sweetalert2";
import { productsColumns } from "../../store/products/ProductsData";
import instance, { imageUrl, uploadInstance } from "../api";
// import axios from "axios"

function ProductsList() {
  const { product_id } = useParams();
  // NEW CODE
  const [ searchText, setSearchText ] = useState("")
  // NEW CODE ENDS

  const [showModal, setShowModal] = useState(false);
  const [productsData, setProductsData] = useState([]);
  const [productName, setProductName] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [productImage, setProductImage] = useState(null);
  const [productModel, setProductModel] = useState("");
  const [productQuantity, setProductQuantity] = useState("");
  const [productStockStatusId, setProductStockStatusId] = useState("");
  const [productPrice, setProductPrice] = useState("");
  const [productPricePerPieces, setProductPricePerPieces] = useState("");
  const [productType, setProductType] = useState("");
  // const [IndProductPrice, setIndProductPrice] = useState(0);
  const [shelfLife, setShelfLife] = useState("");
  const [ status, setStatus ] = useState("");
  const [sellIn, setSellIn] = useState("")

  const [productSortOrder, setProductSortOrder] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [editingProduct, setEditingProduct] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [fieldErrors, setFieldErrors] = useState({
    productName: false,
    productImage: false,
    productDescription: false,
    productModel: false,
    productQuantity: false,
    productStockStatusId: false,
    productPrice: false,
    productPricePerPieces: false,
    // IndProductPrice: false,
    shelfLife: false,

    productSortOrder: false,
  });
  const navigate = useNavigate();

  const handleShowModal = () => setShowModal(true);

  const handleCloseModal = () => {
    setShowModal(false);
    navigate("/products-manage/products-list");
    setProductName("");
    setSelectedCategory("");
    setProductDescription("");
    setProductImage(null);
    setProductModel(0);
    setProductQuantity(0);
    setProductStockStatusId(0);
    setProductPrice(0);
    setProductPricePerPieces(0);
    setProductType("");
    // setIndProductPrice(0);
    setShelfLife(0);
    setStatus("");
    setSellIn("");
    setProductSortOrder(0);
    setEditingProduct(null);
    setFieldErrors({
      selectedCategory: false,
      productName: false,
      productImage: false,
      productDescription: false,
      productModel: false,
      productQuantity: false,
      productStockStatusId: false,
      productPrice: false,
      productPricePerPieces: false,
      // IndProductPrice:false,
      shelfLife: false,
      status: false,
      sellIn: false,
      productSortOrder: false,
    });
  };

  const validateForm = () => {
    const errors = {};

    if (!productName) {
      errors.productName = true;
    }
    if (!selectedCategory) {
      errors.selectedCategory = true;
    }
    
    // Validate pricing - either kilo price or pieces price must be provided, but not both
    const hasKiloPrice = productPrice && productPrice.trim() !== "";
    const hasPiecesPrice = productPricePerPieces && productPricePerPieces.trim() !== "";
    
    if (!hasKiloPrice && !hasPiecesPrice) {
      errors.productPrice = true;
      errors.productPricePerPieces = true;
    } else if (hasKiloPrice && hasPiecesPrice) {
      errors.productPrice = true;
      errors.productPricePerPieces = true;
    }
    
    // if (!status) {
    //   errors.status = true;
    // }

    setFieldErrors(errors);

    return !Object.values(errors).some((error) => error);
  };

  const handleFileInputClick = () => {
    document.getElementById("product-image-upload-input").click();
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    setProductImage(file);
  };

  const fetchProductDetails = async () => {
    try {
      const response = await instance.get(`api/Product/${product_id}`);
      const product = response.data;
      setProductName(product.name || "");
      setProductDescription(product.description || "");
      setProductModel(product.model || 0);
      setProductImage(product.image || "");
      setProductQuantity(product.quantity || 0);
      setProductStockStatusId(product.stock_status_id || 0);
      
      // Set the price in the appropriate field based on the product type
      if (product.type === "kgs") {
        setProductPrice(product.price || 0);
        setProductPricePerPieces(0);
      } else if (product.type === "pieces") {
        setProductPrice(0);
        setProductPricePerPieces(product.price || 0);
      } else {
        // Fallback for existing products without type
        setProductPrice(product.price || 0);
        setProductPricePerPieces(0);
      }
      
      setProductType(product.type || "");
      // setIndProductPrice(product.ind_price || 0);
      setShelfLife(product.shelf_life || 0);
      setStatus(product.status === 0 ? "Inactive" : "Active" || "");
      setSellIn(product.sell_in || "");
      // setStatus(product.status == 0 ? 0 : 1 || "");

      setProductSortOrder(product.sort_order || 0);
      setSelectedCategory(product.category_id || ""); // Set selected category

      setEditingProduct(product);
      handleShowModal();
    } catch (error) {
      console.error("Error fetching Product details:", error);
    }
  };

  const postProductData = async () => {
    if (!validateForm()) {
      return;
    }

    try {
      // Determine the type based on which pricing is provided
      const hasKiloPrice = productPrice && productPrice.trim() !== "";
      const hasPiecesPrice = productPricePerPieces && productPricePerPieces.trim() !== "";
      
      let type = "";
      let finalPrice = "";
      if (hasKiloPrice && !hasPiecesPrice) {
        type = "kgs";
        finalPrice = productPrice;
      } else if (hasPiecesPrice && !hasKiloPrice) {
        type = "pieces";
        finalPrice = productPricePerPieces;
      }

      let payload = {
        category_id: selectedCategory,
        name: productName,
        description: productDescription,
        // model: productModel,
        // quantity: productQuantity,
        // stock_status_id: productStockStatusId,
        price: finalPrice,
        type: type,
        // ind_price:IndProductPrice,
        shelf_life: shelfLife,
        status: status === "Active" ? 1 : 0,
        // sort_order: productSortOrder,
      };
      // console.log("Product payload:", payload);

      if (productImage instanceof File) {
        const formData = new FormData();
        formData.append("files", productImage);

        const uploadResponse = await uploadInstance.post(
          "api/Common/Upload",
          formData
        );

        if (uploadResponse.data.message === "uploaded file.") {
          payload.image = uploadResponse.data.file_paths;
        }
      }

      let productResponse;
      if (editingProduct) {
        productResponse = await instance.put(
          `api/Product/update/${editingProduct.product_id}`,
          payload
        );
      } else {
        productResponse = await instance.post("api/Product/create", payload);
      }

      // console.log("Product response:", productResponse.data);

      handleCloseModal();
      Swal.fire("Success", "Product updated successfully!", "success");

      const updatedResponse = await instance.get("api/Product?pageSize=100000");
      setProductsData(updatedResponse.data.rows);
    } catch (error) {
      Swal.fire("Error", "Failed to update Product!", "error");
    }
  };

  const fetchData = async (page, pageSize) => {
    try {
      const queryParams = `page_size=${pageSize}&page=${page}` + 
                      (searchText ? `&search=${searchText}` : '');
      const response = await instance.get(
        // `/api/Product/list?page_size=${pageSize}&page=${page}`
        `/api/Product/list?${queryParams}`
      );

      setProductsData(response.data.rows);
      setTotalCount(response.data.count);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchData(page, rowsPerPage);
    if (product_id) {
      fetchProductDetails();
    }
  // }, [product_id, page, rowsPerPage]);
  }, [ product_id, page, rowsPerPage, searchText ]);



  // NEW CODE
    const handleSearchTextChange = (text) => {
    setSearchText(text);
    };
// NEW CODE ENDS

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setRowsPerPage(newSize);
    setPage(0);
  };

  const fetchCategories = async () => {
    try {
      const response = await instance.get("api/Category");
      setCategoryOptions(response.data.rows);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const productColumns = productsColumns({ setProductsData });

  return (
    <Layout title="Products List" content="container">
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">Products List</Block.Title>
            {/* <nav>
              <ol className="breadcrumb breadcrumb-arrow mb-0">
                <li className="breadcrumb-item">
                  <Link to="/home-ecommerce">Home</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="">Products Manage</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Products
                </li>
              </ol>
            </nav> */}
          </Block.HeadContent>
          <Block.HeadContent>
            <ul className="d-flex">
              <li>
                <Button
                  className="d-md-none"
                  size="md"
                  variant="primary"
                  onClick={handleShowModal}
                >
                  <Icon name="plus" />
                  <span>Add</span>
                </Button>
              </li>
              <li>
                <Button
                  className="d-none d-md-inline-flex"
                  variant="primary"
                  onClick={handleShowModal}
                >
                  <Icon name="plus" />
                  <span>Add Product</span>
                </Button>
              </li>
            </ul>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>

      <Block>
        <Card>
          <DataTable
            tableClassName="data-table-head-light table-responsive"
            data={productsData}
            columns={productColumns}
            searchList={["name"]}
            searchTerm="Product Name"
            totalCount={totalCount}
            page={page}
            rowsPerPage={rowsPerPage}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            // NEW ONE 
            onSearchTextChange={handleSearchTextChange}
            // NEW ONE ENDS
          />
        </Card>
      </Block>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            {editingProduct ? "Edit Product" : "Add Product"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="mb-3">
              <Form.Group as={Col}>
                <Form.Label>Category</Form.Label>
                <Form.Select
                  value={selectedCategory}
                  onChange={(e) =>
                    setSelectedCategory(parseInt(e.target.value))
                  }
                  isInvalid={fieldErrors.selectedCategory}
                >
                  <option value="">Select category</option>
                  {categoryOptions.map((category) => (
                    <option
                      key={category.category_id}
                      value={category.category_id}
                    >
                      {category.name}
                    </option>
                  ))}
                </Form.Select>
                {/* <Form.Control
                  as="select"
                  value={selectedCategory}
                  onChange={(e) =>
                    setSelectedCategory(parseInt(e.target.value))
                  }
                  isInvalid={fieldErrors.selectedCategory}
                >
                  <option value="">Select category</option>
                  {categoryOptions.map((category) => (
                    <option
                      key={category.category_id}
                      value={category.category_id}
                    >
                      {category.name}
                    </option>
                  ))}
                </Form.Control> */}
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col}>
                <Form.Label>Product Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter product name"
                  value={productName}
                  onChange={(e) => setProductName(e.target.value)}
                  isInvalid={fieldErrors.productName}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a product name.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Product Description</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter product description"
                  value={productDescription}
                  onChange={(e) => setProductDescription(e.target.value)}
                  isInvalid={fieldErrors.productDescription}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a product description.
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            {/* <Row className="mb-3">
              <Form.Group as={Col}>
                <Form.Label>Product Model</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter product model"
                  value={productModel}
                  onChange={(e) =>
                    setProductModel(
                      e.target.value
                      // parseInt(
                      //   e.target.value === ""
                      //     ? 0
                      //     : e.target.value.replace(/\D/, "")
                      // )
                    )
                  }
                  isInvalid={fieldErrors.productModel}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a product model.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Product Quantity</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter product quantity"
                  value={productQuantity}
                  onChange={(e) =>
                    setProductQuantity(
                      e.target.value
                      // parseInt(
                      //   e.target.value === ""
                      //     ? 0
                      //     : e.target.value.replace(/\D/, "")
                      // )
                    )
                  }
                  isInvalid={fieldErrors.productQuantity}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a product quantity.
                </Form.Control.Feedback>
              </Form.Group>
            </Row> */}
            <Row className="mb-3">
              <Col>
                <div className="alert alert-info" role="alert">
                  <strong>Note:</strong> Please enter either the price per kilo OR the price per 10 pieces, but not both.
                </div>
              </Col>
            </Row>
            <Row className="mb-3">
              {/* <Form.Group as={Col} >
                                <Form.Label>India Price</Form.Label>
                                <Form.Control type="number" placeholder="Enter product price" value={IndProductPrice} onChange={(e) => setIndProductPrice(parseFloat(e.target.value))} isInvalid={fieldErrors.productPrice} />
                                <Form.Control.Feedback type="invalid">Please enter a product price.</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group as={Col} >
                                <Form.Label>Outside India Price</Form.Label>
                                <Form.Control type="number" placeholder="Enter product price" value={productPrice} onChange={(e) => setProductPrice(parseFloat(e.target.value))} isInvalid={fieldErrors.IndProductPrice} />
                                <Form.Control.Feedback type="invalid">Please enter a product price.</Form.Control.Feedback>
                            </Form.Group> */}

              <Form.Group as={Col}>
                <Form.Label>
                  {" "}
                  Price{" "}
                  <span
                    style={{
                      color: "gray",
                      opacity: "0.5",
                      fontWeight: "normal",
                    }}
                  >
                    /Kelo
                  </span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter product price"
                  value={productPrice}
                  onChange={(e) =>
                    setProductPrice(
                      e.target.value
                      // parseFloat(
                      //   e.target.value === ""
                      //     ? 0
                      //     : e.target.value.replace(/\D/, "")
                      // )
                    )
                  }
                  isInvalid={fieldErrors.productPrice}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter either kilo price or pieces price, not both.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>
                  Price{" "}
                  <span
                    style={{
                      color: "gray",
                      opacity: "0.5",
                      fontWeight: "normal",
                    }}
                  >
                    /10 Pieces
                  </span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter price per 10 pieces"
                  value={productPricePerPieces}
                  onChange={(e) =>
                    setProductPricePerPieces(
                      e.target.value
                      // parseFloat(
                      //   e.target.value === ""
                      //     ? 0
                      //     : e.target.value.replace(/\D/, "")
                      // )
                    )
                  }
                  isInvalid={fieldErrors.productPricePerPieces}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter either kilo price or pieces price, not both.
                </Form.Control.Feedback>
              </Form.Group>
              </Row>

 
            {/* NEW FIELD */}
            {editingProduct && (
              <Row className="mb-3">
                <Form.Group as={Col}>
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    isInvalid={fieldErrors.status}
                  >
                    <option value="">Select Status</option>
                    <option value={"Active"}>Active</option>
                    <option value={"Inactive"}>Inactive </option>

                    {/* {statusList.map((category) => (
                    <option
                      key={category.category_id}
                      value={category.category_id}
                    >
                      {category.name}
                    </option>
                  ))} */}
                  </Form.Select>
                </Form.Group>
              </Row>
            )}


            {/* SELL IN */}
             {/* <Row className="mb-3">
                <Form.Group as={Col}>
                  <Form.Label>Sell In</Form.Label>
                  <Form.Select
                    value={sellIn}
                    onChange={(e) => setSellIn(e.target.value)}
                    isInvalid={fieldErrors.sellIn}
                  >
                    <option value="">Select Sell In Option</option>
                    <option value={"Both"}>Both</option>
                    <option value={"India"}>India </option>
                    
                    <option value={"International"}>International </option>

      
                  </Form.Select>
                </Form.Group>
            </Row> */}
            

            <Row className="mb-3">
              <Form.Group as={Col}>
                <Form.Label>Shelf Life</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter shelf life"
                  value={shelfLife}
                  onChange={(e) =>
                    setShelfLife(
                      e.target.value
                      // parseFloat(
                      //   e.target.value === ""
                      //     ? 0
                      //     : e.target.value.replace(/\D/, "")
                      // )
                    )
                  }
                  isInvalid={fieldErrors.shelfLife}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a shelf life.
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col}>
                <Form.Label>Product Image</Form.Label>
                <div className="d-flex align-items-center">
                  <Form.Control
                    type="file"
                    id="product-image-upload-input"
                    style={{ display: "none" }}
                    onChange={handleImageUpload}
                  />
                  <Button variant="primary" onClick={handleFileInputClick}>
                    Upload Image
                  </Button>
                  {fieldErrors.productImage && (
                    <Form.Control.Feedback type="invalid">
                      Please upload a product image.
                    </Form.Control.Feedback>
                  )}
                  {productImage && (
                    <img
                      src={
                        productImage instanceof File
                          ? URL.createObjectURL(productImage)
                          : `${imageUrl}${productImage}`
                      }
                      alt="Product"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "80px",
                        marginTop: "10px",
                      }}
                    />
                  )}
                </div>
              </Form.Group>
            </Row>
            <Button variant="primary" onClick={postProductData}>
              {editingProduct ? "Update Product" : "Add Product"}
            </Button>{" "}
            <Button variant="secondary" onClick={handleCloseModal}>
              Cancel
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </Layout>
  );
}

export const handleDeleteProduct = async (product_id, setProductsData) => {
  const confirmed = window.confirm(
    "Are you sure you want to delete this Product?"
  );
  if (confirmed) {
    try {
      await instance.delete(`api/Product/delete/${product_id}`);
      // console.log(`product with ID ${product_id} deleted successfully.`);
      Swal.fire("Success", "Product deleted successfully!", "success");

      const updatedResponse = await instance.get("api/Product?pageSize=100000");
      setProductsData(updatedResponse.data.rows);
    } catch (error) {
      console.error(`Error deleting product with ID ${product_id}:`, error);
      Swal.fire("Error", "Failed to delete Product!", "error");
    }
  }
};

export default ProductsList;
